import { configureStore } from "@reduxjs/toolkit";

import appReducer from "./slices/appSlice";
import bookDeliveryReducer from "./slices/bookDeliverySlice";
import snackbarReducer from "./slices/snackbarSlice";

import { Vehicle } from "../Interfaces/vehicle.type";

export interface storeType {
  app: {
    exportFlag: boolean;
  };
  bookDelivery: {
    selectedForDelivery: Vehicle[];
  };
  snackbar: {
    snackbarState: boolean;
  };
}

export const store = configureStore({
  reducer: {
    app: appReducer,
    bookDelivery: bookDeliveryReducer,
    snackbar: snackbarReducer,
  },
});
